import logo from "./logo.svg";
import "./App.css";
import lws from "./assets/lws.svg";
import search from "./assets/search.svg";
import Card from "./Component/Redux/itemCard/Card";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { resetAllDataAction } from "./Component/Redux/action/action";
import { useState } from "react";
import { useMemo } from "react";
import UseDebounce from "./Component/Redux/useDebounce/UseDebounce";

function App() {
  const { article, admin, initialState } = useSelector(
    (state) => state.allData
  );
  const dispatch = useDispatch();
  const [inputSearch, setInputSearch] = useState("");
  const debouncedSearchTerm = UseDebounce(inputSearch, 500);

  const countries = useMemo(() => {
    if (!inputSearch) return initialState;

    return initialState.filter((todo) => {
      return todo.title
        .toLowerCase()
        .includes(debouncedSearchTerm.toLowerCase());
    });
  }, [debouncedSearchTerm, initialState]);

  // function searchFunction(item, inputSearch) {
  //   let timeOutId;
  //   return function () {
  //     if (timeOutId) {
  //       clearTimeout(timeOutId);
  //     }
  //     timeOutId = setTimeout(() => {
  //       item.filter((todo) =>
  //         todo.title.toLowerCase().includes(inputSearch.toLowerCase())
  //       );
  //     }, 1000);
  //   };
  // }

  return (
    <div className="App">
      {/* <!-- navigation --> */}
      <nav className="bg-slate-100 shadow-md">
        <div className="max-w-7xl mx-auto px-5 lg:px-0 flex justify-between py-3 items-center">
          <a href="index.html">
            <img className="h-10" src={lws} alt="Learn with Sumit" />
          </a>
        </div>
      </nav>

      {/* <!-- search --> */}
      <div className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200">
        <input
          className="outline-none border-none bg-gray-50 h-full w-full mr-2"
          type="text"
          name="search"
          value={inputSearch}
          placeholder="Search"
          onChange={(e) => setInputSearch(e.target.value)}
        />
        <img className="inline h-6 cursor-pointer" src={search} alt="Search" />
      </div>

      <section className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
        <div className="absolute inset-0">
          <div className="bg-white h-1/3 sm:h-2/3"></div>
        </div>
        <div className="relative max-w-7xl mx-auto">
          <div className="text-center">
            <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
              ALL BLOGS ARE HERE
            </h2>
            <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa
              libero labore natus atque, ducimus sed.
            </p>
          </div>
          <div onClick={() => dispatch(resetAllDataAction())}>
            {article.length > 0 ? (
              <h5 className="float-right cursor-pointer">Reset All Data</h5>
            ) : admin.length > 0 ? (
              <h5 className="float-right cursor-pointer">Reset All Data</h5>
            ) : (
              ""
            )}
          </div>
          {/* <!-- card grid  --> */}
          <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
            {countries
              .filter((todo) =>
                article.length > 0 ? article.includes(todo.category) : todo
              )
              .filter((todo) =>
                admin.length > 0 ? admin.includes(todo.admin) : todo
              )
              .map((item) => (
                <Card item={item} key={item.id} />
              ))}
          </div>
        </div>
      </section>

      {/* <!-- footer --> */}
      <section className="pt-6">
        <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex justify-between gap-2 border-t text-sm text-slate-400">
          <div>Copyright 2022 Learn with Sumit.</div>
          <div>
            <a
              href="https://youtube.com/learnwithsumit"
              target="_blank"
              rel="noreferrer"
            >
              YouTube Channel
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
